import { render, staticRenderFns } from "./Shadow.vue?vue&type=template&id=2fca3f4e&scoped=true&"
import script from "./Shadow.vue?vue&type=script&lang=js&"
export * from "./Shadow.vue?vue&type=script&lang=js&"
import style0 from "./Shadow.vue?vue&type=style&index=0&id=2fca3f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca3f4e",
  null
  
)

export default component.exports